import { Heading } from "@/components/atoms/Heading";
import type { ITitleAndDescriptionAppListProps } from "@/components/molecules/TitleAndDescriptionAppList/types";

const TitleAndDescriptionAppList = ({
  title,
  description,
}: ITitleAndDescriptionAppListProps) => {
  return (
    <div className="flex flex-col gap-1 max-sm:px-4">
      <Heading size="h1" fontWeight="bold" className="text-2xl">
        {title}
      </Heading>
      <Heading
        size="h2"
        fontWeight="regular"
        className="text-muted-foreground text-base"
      >
        {description}
      </Heading>
    </div>
  );
};

TitleAndDescriptionAppList.displayName = "TitleAndDescriptionAppList";

export default TitleAndDescriptionAppList;
